import { Link } from "react-router-dom"
import { useAuth } from "../../../providers/AuthProvider";

export const RateLimiting = () => {
    return (
        <div>
            <div className="ui-bg-overlay bg-dark opacity-25"></div>
            <div className="authentication-inner py-5">
                <div className="p-5 text-center k-my-24">
                    <p><b>Too many requests. Please try again later.</b></p>
                </div>
            </div>
        </div>
    )
}